import Vuex from "vuex";
import Vue from "vue";
import Clients from "./modules/Clients";
import Treatments from "./modules/Treatments";
import Galery from "./modules/Galery";
import SideMenu from "./modules/SideMenu";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Clients,
    Treatments,
    Galery,
    SideMenu
  }
});
